import { useEffect, useState } from "react";

/** `value` as it was `delayMs` ago: it only catches up once it has stopped changing, e.g. while a user is typing. */
export const useDebouncedValue = <T>({
  value,
  delayMs,
}: {
  value: T;
  delayMs: number;
}): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeoutId);
  }, [value, delayMs]);

  return debouncedValue;
};
